import {
  createFormSubmission as coreCreateFormSubmission,
  updateFormSubmission as coreUpdateFormSubmission,
} from '@witmetrics/unison-core';
import { API } from '@/api';
import type { Answers } from '@/providers/FormProvider';

export const createFormSubmission = (versionId: number, answers: Answers) =>
  coreCreateFormSubmission(API, versionId, answers);

export const updateFormSubmission = (submissionId: number, answers: Answers) =>
  coreUpdateFormSubmission(API, submissionId, answers);
